import { ReactNode, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import styles from './DashboardLayout.module.css';

interface DashboardLayoutProps {
  children: ReactNode;
  sidebarContext?: 'dashboard' | 'project';
  projectId?: string;
  topBarTitle?: string;
  onSearch?: (query: string) => void;
  searchPlaceholder?: string;
  topBarActions?: ReactNode;
}

const DashboardLayout = ({
  children,
  sidebarContext = 'dashboard',
  projectId,
  topBarTitle,
  onSearch,
  searchPlaceholder,
  topBarActions,
}: DashboardLayoutProps) => {
  const { isAuthenticated, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) return null;
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className={styles.layout}>
      <Sidebar
        context={sidebarContext}
        projectId={projectId}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <main className={styles.main}>
        <TopBar
          title={topBarTitle}
          onSearch={onSearch}
          searchPlaceholder={searchPlaceholder}
          actions={topBarActions}
          onMenuClick={() => setSidebarOpen((prev) => !prev)}
        />
        <div className={styles.content}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
